import FaqSection from "@/components/sections/products/shared/faq";
import { linkifyFirstMatch } from "@/components/sections/products/shared/faq/linkify";
import { RESIDENTIAL_PRICING_FAQS } from "./data";

const LINK_TARGETS = [
  { phrase: "Acceptable Use Policy", href: "/legal/acceptable-use-policy" },
  { phrase: "Tier 1 KYC verification", href: "/kyc" },
];

const faqs = RESIDENTIAL_PRICING_FAQS.map((faq) => ({
  ...faq,
  a: linkifyFirstMatch(faq.a, LINK_TARGETS),
}));

export default function ResidentialPricingFaq() {
  return (
    <FaqSection
      faqs={faqs}
      description="Everything you need to know about our residential proxy plans, billing, and setup. Can't find what you're looking for?"
      headingId="residential-faq-heading"
      contactVariant="button"
    />
  );
}
